import { render, staticRenderFns } from "./receiving-address.vue?vue&type=template&id=4cc63d8b&scoped=true"
import script from "./receiving-address.vue?vue&type=script&lang=js"
export * from "./receiving-address.vue?vue&type=script&lang=js"
import style0 from "./receiving-address.vue?vue&type=style&index=0&id=4cc63d8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc63d8b",
  null
  
)

export default component.exports